import { AbilityBuilder } from '@casl/ability'

export default AbilityBuilder.define(can => {
  can(['read', 'create', 'sendProcess', 'update', 'administration'], 'admin')// rh
  can('read', 'test')

  can('read', '4')// invitado
  can(['read', 'create', 'sendProcess', 'update', 'verRH'], '3')// rh
  can(['read', 'create', 'sendProcess', 'update', 'selectCandidato'], '2')// admin
  can(['read', 'create', 'selectCandidato'], '1')// gerente

  can(['read', 'create', 'selectCandidato', 'sendProcess', 'update', 'verRH'], '9')// gerente
})
